import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MyThunkDispatch, RootState } from 'store';

import { getCompanyBilling } from 'actions/companyBilling';
import { fetchNationalityCountryList } from 'actions/i18n';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import CompanyBillingForm from 'screens/components/CompanyBillingForm';
import { extractErrorMessage } from 'utils/generic';

const CompanyBillingEditContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const { company, isLoading, error } = useSelector((state: RootState) => state.companyBilling);
  const toast = useToast();
  const { t } = useStoreTranslation();

  const { accountResult } = useSelector((state: RootState) => state.user);
  const companyId = accountResult ? accountResult.companyId : '';

  const { loadingNationalityCountries, nationalityCountries } = useSelector((state: RootState) => state.i18n);
  useEffect(() => {
    if (error) toast.add({ type: 'danger', message: extractErrorMessage(error) || t('defaultError.default') });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(
    () => {
      if (!isLoading) {
        dispatch(getCompanyBilling(companyId));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    if (!nationalityCountries.length && !loadingNationalityCountries) {
      dispatch(fetchNationalityCountryList());
    }
  }, [dispatch, nationalityCountries, loadingNationalityCountries]);

  return (
    <CompanyBillingForm
      isLoading={isLoading || loadingNationalityCountries}
      company={company}
      countries={nationalityCountries}
    />
  );
};

export default CompanyBillingEditContainer;
